import { render, staticRenderFns } from "./UsageReportDetails.vue?vue&type=template&id=392ecf6b"
import script from "./UsageReportDetails.vue?vue&type=script&lang=js"
export * from "./UsageReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports